import * as yup from 'yup'

const StructuredProductFilterValidationSchema = yup.object().shape({
    selectedCategoryId: yup.number().required('This Field is required'),
    selectedProduct: yup.object().nullable().required('This Field is required'),
    selectedVariant: yup.object().nullable().required('This Field is required'),
    selectedBrand: yup.object().nullable().required('This Field is required')
  })
  
const StructuredProductFilterInitialState = {
    selectedCategoryId: null,
    selectedProduct: null,
    selectedVariant: null,
    selectedBrand: null,
    selectedAttributes: {}
}

export { StructuredProductFilterValidationSchema, StructuredProductFilterInitialState }